var AURA_DEMO_CART_KEY = 'aura_shopify_demo_cart';

function demoProducts() {
  return window.AURA_DEMO_PRODUCTS || {};
}

function readDemoCart() {
  try {
    return JSON.parse(localStorage.getItem(AURA_DEMO_CART_KEY) || '[]');
  } catch (error) {
    return [];
  }
}

function writeDemoCart(cart) {
  localStorage.setItem(AURA_DEMO_CART_KEY, JSON.stringify(cart));
  renderDemoCart();
  syncCartState();
}

function demoCartCount() {
  return readDemoCart().reduce(function (sum, line) {
    return sum + Number(line.qty || 0);
  }, 0);
}

function setCartBubble(count) {
  var cartLink = document.querySelector('.cart-count-bubble');
  if (!cartLink) return;
  var bubble = cartLink.querySelector('small');
  if (!bubble && count > 0) {
    bubble = document.createElement('small');
    cartLink.appendChild(bubble);
  }
  if (bubble) {
    bubble.textContent = count;
    bubble.hidden = count === 0;
  }
}

function updateDemoCartBubble() {
  setCartBubble(demoCartCount());
}

function addDemoCartItem(handle, qty) {
  var products = demoProducts();
  if (!products[handle]) return false;
  var cart = readDemoCart();
  var existing = cart.find(function (line) {
    return line.handle === handle;
  });
  if (existing) existing.qty += qty;
  else cart.push({ handle: handle, qty: qty });
  writeDemoCart(cart);
  return true;
}

function money(value) {
  return '$' + Number(value || 0).toFixed(2);
}

function formatCartMoney(cents) {
  var currency = window.AURA_MONEY_CURRENCY || 'USD';
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency
    }).format(Number(cents || 0) / 100);
  } catch (error) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }
}

function escapeHtml(value) {
  return String(value || '').replace(/[&<>"']/g, function (char) {
    return {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    }[char];
  });
}

function fallbackImageForProduct(handle, title) {
  var images = window.AURA_FALLBACK_IMAGES || {};
  var haystack = String((handle || '') + ' ' + (title || '')).toLowerCase();
  if (haystack.indexOf('river') !== -1 || haystack.indexOf('bowl') !== -1) return images.riverstone || images.dune || '';
  if (haystack.indexOf('lumen') !== -1 || haystack.indexOf('mug') !== -1 || haystack.indexOf('cup') !== -1) return images.lumen || images.dune || '';
  if (haystack.indexOf('atelier') !== -1 || haystack.indexOf('cutlery') !== -1 || haystack.indexOf('fork') !== -1 || haystack.indexOf('spoon') !== -1) return images.atelier || images.dune || '';
  return images.dune || '';
}

function fetchShopifyCart() {
  return fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (response) {
      if (!response.ok) throw new Error('cart fetch failed');
      return response.json();
    })
    .catch(function () {
      return { item_count: 0, total_price: 0, items: [] };
    });
}

function demoCartSubtotalCents() {
  var products = demoProducts();
  return readDemoCart().reduce(function (sum, line) {
    var product = products[line.handle];
    return product ? sum + Math.round(Number(product.price || 0) * 100) * Number(line.qty || 0) : sum;
  }, 0);
}

function cartDrawer() {
  return document.querySelector('[data-cart-drawer]');
}

function openCartDrawer() {
  var drawer = cartDrawer();
  if (!drawer) return;
  drawer.hidden = false;
  document.body.classList.add('cart-drawer-open');
  syncCartState();
}

function closeCartDrawer() {
  var drawer = cartDrawer();
  if (!drawer || drawer.hidden) return;
  drawer.hidden = true;
  document.body.classList.remove('cart-drawer-open');
}

function cartLineMarkup(line) {
  var image = line.image || fallbackImageForProduct(line.handle, line.product_title || line.title);
  var variantText = line.variant_title && line.variant_title !== 'Default Title' ? line.variant_title : '';
  return '<article class="aura-cart-drawer-line">'
    + '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(line.product_title || line.title) + '" loading="lazy">'
    + '<div><a href="' + escapeHtml(line.url || '#') + '">' + escapeHtml(line.product_title || line.title) + '</a><p>' + escapeHtml(variantText || line.desc || '') + '</p>'
    + '<div class="aura-cart-drawer-qty"><button type="button" data-cart-line-change="' + escapeHtml(line.key) + '" data-cart-line-qty="' + (Number(line.quantity) - 1) + '">&minus;</button><span>' + Number(line.quantity || 0) + '</span><button type="button" data-cart-line-change="' + escapeHtml(line.key) + '" data-cart-line-qty="' + (Number(line.quantity) + 1) + '">+</button></div></div>'
    + '<div><strong>' + formatCartMoney(line.final_line_price || 0) + '</strong><button type="button" data-cart-line-change="' + escapeHtml(line.key) + '" data-cart-line-qty="0">Remove</button></div>'
    + '</article>';
}

function demoCartLineMarkup(line) {
  var products = demoProducts();
  var product = products[line.handle];
  if (!product) return '';
  return '<article class="aura-cart-drawer-line">'
    + '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
    + '<div><a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a><p>' + escapeHtml(product.desc) + '</p>'
    + '<div class="aura-cart-drawer-qty"><button type="button" data-demo-cart-change="' + escapeHtml(line.handle) + '" data-demo-cart-qty="' + (Number(line.qty) - 1) + '">&minus;</button><span>' + Number(line.qty || 0) + '</span><button type="button" data-demo-cart-change="' + escapeHtml(line.handle) + '" data-demo-cart-qty="' + (Number(line.qty) + 1) + '">+</button></div></div>'
    + '<div><strong>' + formatCartMoney(Math.round(Number(product.price || 0) * 100) * Number(line.qty || 0)) + '</strong><button type="button" data-demo-cart-change="' + escapeHtml(line.handle) + '" data-demo-cart-qty="0">Remove</button></div>'
    + '</article>';
}

function renderCartDrawer(cart) {
  var drawer = cartDrawer();
  if (!drawer) return;
  var realItems = cart && cart.items ? cart.items : [];
  var demoItems = readDemoCart().filter(function (line) {
    return demoProducts()[line.handle];
  });
  var itemCount = Number(cart && cart.item_count || 0) + demoCartCount();
  var subtotal = Number(cart && cart.total_price || 0) + demoCartSubtotalCents();
  var linesNode = drawer.querySelector('[data-cart-drawer-lines]');
  var countNode = drawer.querySelector('[data-cart-drawer-count]');
  var totalNode = drawer.querySelector('[data-cart-drawer-total]');
  var emptyNode = drawer.querySelector('[data-cart-drawer-empty]');
  var summaryNode = drawer.querySelector('[data-cart-drawer-summary]');
  var progressText = drawer.querySelector('[data-cart-drawer-progress-text]');
  var progressBar = drawer.querySelector('[data-cart-drawer-progress]');
  
  // 修改區域：將免運門檻從 20000 改為 8000 ($80)
var freeShipping = 8000;

  if (countNode) countNode.textContent = itemCount + ' item' + (itemCount === 1 ? '' : 's');
  if (linesNode) linesNode.innerHTML = realItems.map(cartLineMarkup).join('') + demoItems.map(demoCartLineMarkup).join('');
  if (totalNode) totalNode.textContent = formatCartMoney(subtotal);
  if (emptyNode) emptyNode.hidden = itemCount > 0;
  if (summaryNode) summaryNode.hidden = itemCount === 0;
  if (progressText) {
    progressText.textContent = subtotal >= freeShipping
      ? 'You qualify for free shipping.'
      : "You're " + formatCartMoney(freeShipping - subtotal) + ' away from free shipping';
  }
  if (progressBar) progressBar.style.width = Math.min(100, Math.round((subtotal / freeShipping) * 100)) + '%';
  setCartBubble(itemCount);
}

function syncCartState() {
  return fetchShopifyCart().then(function (cart) {
    renderCartDrawer(cart);
    setCartBubble(Number(cart.item_count || 0) + demoCartCount());
    return cart;
  });
}

var lastAccountModalTrigger = null;

function accountModal() {
  return document.querySelector('[data-account-modal]');
}

function showAccountView(view) {
  var modal = accountModal();
  if (!modal) return;
  modal.querySelectorAll('[data-account-view]').forEach(function (panel) {
    panel.hidden = panel.getAttribute('data-account-view') !== view;
  });
}

function refreshAccountModal() {
  var modal = accountModal();
  if (!modal) return;
  var account = !!window.AURA_CUSTOMER_LOGGED_IN;
  var guest = modal.querySelector('[data-account-guest]');
  var member = modal.querySelector('[data-account-member]');
  if (guest) guest.hidden = !!account;
  if (member) member.hidden = !account;
  if (!account) {
    showAccountView('login');
  }
}

function accountTabFromHash() {
  var hash = String(window.location.hash || '').replace('#account-', '');
  return hash || 'dashboard';
}

function setAccountDashboardTab(shell, tab, options) {
  if (!shell) return;
  var next = tab || 'dashboard';
  var panels = Array.from(shell.querySelectorAll('[data-account-panel]'));
  var activePanel = panels.find(function (panel) {
    return panel.getAttribute('data-account-panel') === next;
  });
  if (!activePanel) {
    next = 'dashboard';
    activePanel = panels.find(function (panel) {
      return panel.getAttribute('data-account-panel') === next;
    });
  }
  panels.forEach(function (panel) {
    var active = panel === activePanel;
    panel.hidden = !active;
    panel.classList.toggle('is-active', active);
  });
  shell.querySelectorAll('.account-side-nav [data-account-tab]').forEach(function (link) {
    var active = link.getAttribute('data-account-tab') === next;
    link.classList.toggle('active', active);
    if (active) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });
  if (!options || !options.silent) {
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#account-' + next);
    }
    var main = shell.querySelector('.account-dashboard-main');
    if (main && window.matchMedia('(max-width: 980px)').matches) {
      main.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }
}

function openAccountModal(trigger) {
  var modal = accountModal();
  if (!modal) return;
  lastAccountModalTrigger = trigger || document.activeElement;
  refreshAccountModal();
  if (trigger && trigger.hasAttribute('data-account-open-register')) {
    showAccountView('register');
  }
  modal.hidden = false;
  document.body.classList.add('account-modal-open');
  var dialog = modal.querySelector('.account-modal-dialog');
  if (dialog) dialog.focus();
}

function closeAccountModal() {
  var modal = accountModal();
  if (!modal || modal.hidden) return;
  modal.hidden = true;
  document.body.classList.remove('account-modal-open');
  if (lastAccountModalTrigger && typeof lastAccountModalTrigger.focus === 'function') {
    lastAccountModalTrigger.focus();
  }
}

function trapAccountModalFocus(event) {
  var modal = accountModal();
  if (!modal || modal.hidden || event.key !== 'Tab') return;
  var focusable = Array.from(modal.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'))
    .filter(function (node) {
      return node.offsetParent !== null;
    });
  if (!focusable.length) return;
  var first = focusable[0];
  var last = focusable[focusable.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}

function renderDemoCart() {
  var cartPanel = document.querySelector('[data-demo-cart]');
  if (!cartPanel) return;
  var empty = document.querySelector('[data-demo-cart-empty]');
  var lines = cartPanel.querySelector('[data-demo-cart-lines]');
  var totalNode = cartPanel.querySelector('[data-demo-cart-total]');
  var products = demoProducts();
  var cart = readDemoCart().filter(function (line) {
    return products[line.handle];
  });

  if (!cart.length) {
    cartPanel.hidden = true;
    if (empty) empty.hidden = false;
    if (lines) lines.innerHTML = '';
    if (totalNode) totalNode.textContent = money(0);
    return;
  }

  if (empty) empty.hidden = true;
  cartPanel.hidden = false;
  if (lines) {
    lines.innerHTML = cart.map(function (line) {
      var product = products[line.handle];
      return '<div class="demo-cart-line" data-demo-cart-line><img src="' + product.image + '" alt="' + product.title + '" loading="lazy"><div><a href="' + product.url + '">' + product.title + '</a><p>' + product.desc + '</p><p>' + product.priceText + '</p></div><div class="demo-cart-qty"><span>x ' + line.qty + '</span><button class="secondary-button" type="button" data-demo-remove="' + line.handle + '">Remove</button></div></div>';
    }).join('');
  }
  if (totalNode) {
    var total = cart.reduce(function (sum, line) {
      return sum + products[line.handle].price * Number(line.qty || 0);
    }, 0);
    totalNode.textContent = money(total);
  }
}

function syncDemoSearchFallback() {
  var fallback = document.querySelector('[data-demo-search-fallback]');
  if (!fallback) return;
  var params = new URLSearchParams(window.location.search);
  var query = (params.get('q') || '').trim().toLowerCase();
  var cards = Array.from(fallback.querySelectorAll('[data-demo-search-card]'));
  var visibleCount = 0;
  cards.forEach(function (card) {
    var haystack = (card.getAttribute('data-demo-search-card') || '') + ' ' + card.textContent;
    var visible = !query || haystack.toLowerCase().indexOf(query) !== -1;
    card.hidden = !visible;
    if (visible) visibleCount += 1;
  });
  var note = fallback.querySelector('.demo-cart-empty');
  if (note) {
    note.textContent = visibleCount
      ? 'No Shopify results found yet. Showing matching demo pieces while products are being created.'
      : 'No matching demo pieces found.';
  }
}

document.addEventListener('click', function (event) {
  var accountTrigger = event.target.closest('[data-account-modal-trigger]');
  if (accountTrigger) {
    event.preventDefault();
    if (accountTrigger.hasAttribute('data-account-login-required') && window.AURA_CUSTOMER_LOGGED_IN) {
      window.location.href = '/checkout';
      return;
    }
    openAccountModal(accountTrigger);
    return;
  }

  var accountClose = event.target.closest('[data-account-modal-close]');
  if (accountClose) {
    event.preventDefault();
    closeAccountModal();
    return;
  }

  var accountSwitch = event.target.closest('[data-account-switch]');
  if (accountSwitch) {
    event.preventDefault();
    showAccountView(accountSwitch.getAttribute('data-account-switch') || 'login');
    return;
  }

  var passwordToggle = event.target.closest('[data-account-password-toggle]');
  if (passwordToggle) {
    event.preventDefault();
    var passwordPanel = passwordToggle.closest('[data-account-view]');
    var passwordInput = passwordPanel
      ? passwordPanel.querySelector('[data-account-password]')
      : document.querySelector('[data-account-password]');
    if (!passwordInput) return;
    var showingPassword = passwordInput.type === 'text';
    passwordInput.type = showingPassword ? 'password' : 'text';
    passwordToggle.textContent = showingPassword ? 'Show' : 'Hide';
    return;
  }

  var resetPassword = event.target.closest('[data-account-reset-password]');
  if (resetPassword) {
    event.preventDefault();
    resetPassword.textContent = 'Reset link sent';
    window.setTimeout(function () {
      resetPassword.textContent = 'Send reset link';
      showAccountView('login');
    }, 1000);
    return;
  }

  var accountTab = event.target.closest('[data-account-tab]');
  if (accountTab) {
    var accountShell = accountTab.closest('.account-dashboard-shell');
    if (accountShell) {
      event.preventDefault();
      setAccountDashboardTab(accountShell, accountTab.getAttribute('data-account-tab') || 'dashboard');
      return;
    }
  }

  var demoAdd = event.target.closest('[data-demo-add]');
  if (demoAdd) {
    event.preventDefault();
    var qty = Number(demoAdd.getAttribute('data-demo-qty') || 1);
    var qtySource = demoAdd.getAttribute('data-demo-qty-source');
    if (qtySource) {
      var qtyInput = document.querySelector(qtySource);
      if (qtyInput) qty = Number(qtyInput.value || 1);
    }
    qty = Math.max(1, qty || 1);
    if (addDemoCartItem(demoAdd.getAttribute('data-demo-add'), qty)) {
      var original = demoAdd.textContent;
      demoAdd.textContent = 'Added';
      openCartDrawer();
      window.setTimeout(function () {
        demoAdd.innerHTML = original.indexOf('Quick') !== -1 ? 'Quick add <span aria-hidden="true">-&gt;</span>' : 'Add to cart';
      }, 1100);
    }
    return;
  }

  var remove = event.target.closest('[data-demo-remove]');
  if (remove) {
    var cart = readDemoCart().filter(function (line) {
      return line.handle !== remove.getAttribute('data-demo-remove');
    });
    writeDemoCart(cart);
    return;
  }

  var demoCartChange = event.target.closest('[data-demo-cart-change]');
  if (demoCartChange) {
    var handle = demoCartChange.getAttribute('data-demo-cart-change');
    var nextQty = Math.max(0, Number(demoCartChange.getAttribute('data-demo-cart-qty')) || 0);
    var nextCart = readDemoCart().map(function (line) {
      return line.handle === handle ? { handle: line.handle, qty: nextQty } : line;
    }).filter(function (line) {
      return Number(line.qty || 0) > 0;
    });
    writeDemoCart(nextCart);
    return;
  }

  var cartTrigger = event.target.closest('[data-cart-drawer-trigger]');
  if (cartTrigger) {
    event.preventDefault();
    openCartDrawer();
    return;
  }

  var cartClose = event.target.closest('[data-cart-drawer-close]');
  if (cartClose) {
    event.preventDefault();
    closeCartDrawer();
    return;
  }

  var cartChange = event.target.closest('[data-cart-line-change]');
  if (cartChange) {
    event.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: cartChange.getAttribute('data-cart-line-change'),
        quantity: Math.max(0, Number(cartChange.getAttribute('data-cart-line-qty')) || 0)
      })
    }).then(function () {
      return syncCartState();
    });
    return;
  }

  var clear = event.target.closest('[data-demo-cart-clear]');
  if (clear) {
    writeDemoCart([]);
    return;
  }

  var thumb = event.target.closest('[data-gallery-image]');
  if (thumb) {
    var gallery = thumb.closest('.product-gallery');
    var mainImage = gallery
      ? gallery.querySelector('[data-product-main-image], #ProductMainImage, .product-main-image img')
      : document.getElementById('ProductMainImage');
    if (!mainImage) return;

    var nextImage = thumb.getAttribute('data-gallery-image');
    var nextSrcset = thumb.getAttribute('data-gallery-srcset');
    var nextAlt = thumb.getAttribute('data-gallery-alt');

    if (!nextImage) return;

    var replacement = mainImage.cloneNode(false);
    replacement.removeAttribute('srcset');
    replacement.removeAttribute('sizes');
    replacement.setAttribute('data-product-main-image', '');
    replacement.src = nextImage;
    replacement.alt = nextAlt || mainImage.alt || '';
    replacement.loading = 'eager';
    replacement.decoding = 'async';
    mainImage.replaceWith(replacement);

    (gallery || document).querySelectorAll('[data-gallery-image]').forEach(function (node) {
      node.classList.toggle('active', node === thumb);
    });
    return;
  }

  var minus = event.target.closest('[data-qty-minus]');
  var plus = event.target.closest('[data-qty-plus]');
  if (!minus && !plus) return;

  var control = event.target.closest('.qty-control');
  var input = control ? control.querySelector('input[type="number"]') : null;
  if (!input) return;

  var current = Math.max(1, Number(input.value) || 1);
  input.value = plus ? current + 1 : Math.max(1, current - 1);
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    closeAccountModal();
    closeCartDrawer();
    return;
  }
  trapAccountModalFocus(event);
});

document.addEventListener('submit', function (event) {
  var form = event.target;
  if (!form || !form.matches('form[action*="/cart/add"], .quick-add-form, .product-form')) return;
  if (form.hasAttribute('data-no-ajax-cart')) return;

  event.preventDefault();
  var button = form.querySelector('button[type="submit"]');
  var original = button ? button.innerHTML : '';
  if (button) {
    button.disabled = true;
    button.textContent = 'Adding';
  }

  fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json' },
    body: new FormData(form)
  }).then(function (response) {
    if (!response.ok) throw new Error('add failed');
    return syncCartState();
  }).then(function () {
    if (button) button.textContent = 'Added';
    openCartDrawer();
    window.setTimeout(function () {
      if (button) {
        button.disabled = false;
        button.innerHTML = original;
      }
    }, 900);
  }).catch(function () {
    if (button) {
      button.disabled = false;
      button.innerHTML = original;
    }
    form.submit();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.account-dashboard-shell').forEach(function (shell) {
    setAccountDashboardTab(shell, accountTabFromHash(), { silent: true });
  });
  renderDemoCart();
  refreshAccountModal();
  syncCartState();
  syncDemoSearchFallback();
});